<template>
  <Button
    v-tooltip.bottom="tooltipText"
    :icon="currentIcon"
    text
    rounded
    aria-label="Toggle theme"
    @click="toggleTheme"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Button from 'primevue/button';

import { useUIStore } from '@/stores/ui';

const uiStore = useUIStore();

const themeSequence: Array<'light' | 'dark' | 'auto'> = ['light', 'dark', 'auto'];

const currentIcon = computed(() => {
  switch (uiStore.theme) {
    case 'light': {
      return 'pi pi-sun';
    }
    case 'dark': {
      return 'pi pi-moon';
    }
    case 'auto': {
      return 'pi pi-sync';
    }
    default: {
      return 'pi pi-sync';
    }
  }
});

const tooltipText = computed(() => {
  switch (uiStore.theme) {
    case 'light': {
      return 'Theme: Light';
    }
    case 'dark': {
      return 'Theme: Dark';
    }
    case 'auto': {
      return 'Theme: Auto';
    }
    default: {
      return 'Theme: Auto';
    }
  }
});

function toggleTheme(): void {
  const currentIndex = themeSequence.indexOf(uiStore.theme);
  const nextIndex = (currentIndex + 1) % themeSequence.length;
  uiStore.setTheme(themeSequence[nextIndex]);
}
</script>
